export enum TaskStatus {
    Open,
    DueToday,
    Overdue,
    Complete
}
